export default __webpack_public_path__ + "static/media/tasty-tuesday.d59ed4e5.svg";